import moment from "moment";

export function formatPhone(phone) {
  if (!phone) {
    return "N/A";
  }

  const regex = /([\d]{3})([\d]{3})([\d]{4})/g;
  const substr = "($1) $2-$3";
  return phone.replace(regex, substr);
}

export function formatDate(timestamp, format = "DD/MM/YYYY hh:mm a") {

  if (timestamp === 0) {
    return "N/A";
  }
 
  return moment(timestamp).format(format);
}
export function formatDateNew(timestamp, format = "DD/MM/YYYY hh:mm a") {
  if (!timestamp) return "N/A";

  return moment(timestamp.seconds * 1000).format(format);
}
